import { useMutation, UseMutationOptions } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Variables = {
  weeklyBudget: number
}

export const createOnboardingCampaign = async ({ workspaceId, weeklyBudget }: Variables & { workspaceId: number }) => {
  const res = await sendToApi<void>(`/w/${workspaceId}/ad_campaigns/create_onboarding_campaign`, {
    method: 'POST',
    body: {
      weekly_budget: weeklyBudget,
    },
  })

  if (res.type === 'exception' && res.data instanceof DOMException && res.data.name === 'AbortError') {
    throw res.data
  }
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    if (res.data === 'cancel') throw new DOMException('The operation was aborted.', 'AbortError')
    throw new Error(res.data)
  }
  return res.data
}

export interface Options extends Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'> {}

export const useCreateOnboardingCampaign = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<void, Error, Variables>(
    (variables) => createOnboardingCampaign({ workspaceId, ...variables }),
    options,
  )
}
